<template>
    <div>
        <base-loading :visible="isLoading" />
        <base-sidebar :isOpen="value" :title="$t('transaction') | capitalize" size="sm">

            <template v-slot:body>
                <vs-row>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('client') | capitalize" :placeholder="$t('client') | capitalize"
                            class="w-full" :value="account.ClientName" disabled />
                    </vs-col>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('account') | capitalize" :placeholder="$t('account') | capitalize"
                            class="w-full" :value="account.account_suffix" disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('reference') | capitalize" :placeholder="$t('reference') | capitalize"
                            class="w-full" :value="transaction.ref" disabled />
                    </vs-col>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('date') | capitalize" :placeholder="$t('date') | capitalize"
                            :value="renderDate(transaction.entry_date)" class="w-full" disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('amount') | capitalize" :placeholder="$t('amount') | capitalize"
                            :value="transaction.amount" class="w-full" disabled />
                    </vs-col>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('currency') | capitalize" :placeholder="$t('currency') | capitalize"
                            :value="account.currency" class="w-full" disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mt-4">
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('amount') | capitalize" :placeholder="$t('amount') | capitalize"
                            :value="transaction.amount" class="w-full" disabled />
                    </vs-col>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('currency') | capitalize" :placeholder="$t('currency') | capitalize"
                            :value="account.currency" class="w-full" disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mt-4">
                    <vs-col class='px-4' vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                        <label style="font-size: .85rem">{{ $t('link') }}</label>
                    </vs-col>
                    <vs-col class="px-2" vs-w="12">
                        <v-select label="name" :placeholder="$tc('type', 1) | capitalize" :options="linkTypes"
                            v-model="linkType" class="w-full">
                            <template #option="{ name }">
                                {{ $t(name) | capitalize }}
                            </template>
                            <template #selected-option="{ name }">
                                {{ $t(name) | capitalize }}
                            </template>
                        </v-select>
                    </vs-col>
                </vs-row>
                <div v-if="linkType.id == '1'">
                    <vs-row class="mt-4">
                        <vs-col class='px-4' vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                            <label style="font-size: .85rem">{{ $t('vendor') }}</label>
                        </vs-col>
                        <vs-col class="px-2" vs-w="10">
                            <VendorSelect v-model="vendor.selected" :disabled="vendor.disabled" />
                        </vs-col>
                        <vs-col class="px-2" vs-w="2">
                            <vs-button class="w-full" color="success" icon="lock"
                                :disabled="vendor.selected == null || vendor.disabled" @click="getExpenses">
                                {{ $t('assign') | capitalize }}
                            </vs-button>
                        </vs-col>
                    </vs-row>

                    <vs-row class="mt-4" v-if="vendor.disabled == true">
                        <vs-col class='px-4' vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                            <label style="font-size: .85rem">{{ $t('expense') | capitalize }}</label>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" class="px-2">
                            <v-select :options="availableExpenses" class="w-full" v-model="expense">
                                <template #option="{ expenseId, folio, total, currency }">
                                    {{ expenseId }} - {{ folio }} - $ {{ total }} - {{ currency }}
                                </template>
                                <template #selected-option="{ expenseId, folio, total, currency }">
                                    {{ expenseId }} - {{ folio }} - $ {{ total }} - {{ currency }}
                                </template>
                            </v-select>
                        </vs-col>
                    </vs-row>
                </div>
                <vs-row class="mt-4" v-if="linkType.id == '2'">
                    <vs-col class='px-4' vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                        <label style="font-size: .85rem">{{ $t('amount') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2" vs-w="12">
                        <vs-input class="w-full" type="number" :placeholder="$t('amount') | capitalize" v-model="amount" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col class='px-4' vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                        <label style="font-size: .85rem">{{ $t('comments') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2" vs-w="12">
                        <vs-input class="w-full" :placeholder="$t('comments') | capitalize" v-model="comment" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" class="px-2">
                        <vs-button color="success" icon="add" @click="addItem" class="w-full">
                            {{ $t('add') }}
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                        <link-expenses-table :items="items" class="w-full" :total="total"
                            :currency="account.currency" />
                    </vs-col>
                </vs-row>
            </template>
            <template v-slot:footer>
                <vs-button color="danger" icon="cancel" type="flat" @click="emit('input', false)">
                    {{ $t('cancel') }}
                </vs-button>
                <vs-button color="success" icon="save" type="flat" @click="submit" :disabled="total>transaction.amount">
                    {{ $t('save') }}
                </vs-button>
            </template>
        </base-sidebar>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useNotifier } from '@/composables/useNotifier';
import BaseSidebar from '@/views/app/components/BaseSidebar.vue'
import BaseLoading from '@/views/app/components/BaseLoading'
import vSelect from 'vue-select'
import VendorSelect from './VendorSelect.vue'
import { useReportTransactions } from '../../../composables/useReportTransactions'
import LinkExpensesTable from './LinkExpensesTable.vue'
import { renderDate } from '@/utils/helpers'

const props = defineProps({
    value: { type: Boolean, default: false },
    transaction: { type: Object, default: () => ({}) },
    account: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['input', 'submit'])
const { notify } = useNotifier();
const reportTransactions = useReportTransactions()
const isLoading = computed(() => reportTransactions.state.loading)
const expenses = ref([])
const expense = ref(null)
const vendor = ref({ selected: null, disabled: false })
const items = ref([])
const linkTypes = ref([])
const linkType = ref({})
const comment = ref('')
const amount = ref('')

const availableExpenses = computed(() => {
    return expenses.value.filter(expense =>
        !items.value.some(item => item.expenseId === expense.expenseId)
    )
})

watch(() => props.value, (newValue) => {
    if (newValue) {
        expense.value = null
        items.value = []
        expenses.value = []
        vendor.value = { selected: null, disabled: false }
        getTransaction()
        getlinkTypes()
    }
})

const total = computed(() => {
    return items.value.reduce((sum, el) => sum + Number(el.amount), 0)
})

const addItem = () => {
    let item = {
        typeId: linkType.value.id,
        typeName: linkType.value.name,
        comment: comment.value,
        id:null,
        amount:amount.value
    }
    if (linkType.value.id == '1') {
        item.amount = expense.value.total,
        item.id = expense.value.expenseId
    }
    items.value = [...items.value, item]
}
const getTransaction = async () => {
    console.log(1)
    const payload = {
        transactionId: props.transaction.id,
    }
    const result = await reportTransactions.getTransaction(payload)
    if (!result.success) {
        notify({ title: 'attention', text: 'message_error', color: 'warning' })
        return
    }
    items.value = [...result.response.expenses]
    vendor.value = { selected: { ...result.response.vendor }, disabled: false }
    getExpenses()

}

const getExpenses = async () => {
    vendor.value.disabled = true
    const payload = {
        currency: props.account.currency,
        transactionId: props.transaction.id,
        transactionDate: props.transaction.entry_date,
        vendorId: vendor.value.selected.id
    }
    const res = await reportTransactions.getExpenses(payload)
    expenses.value = [...res.response.expenses]
}

const getlinkTypes = async () => {
    const res = await reportTransactions.getLinkTypes()
    linkTypes.value = [...res.response.linkTypes]
}

const submit = async () => {
    const payload = {
        transactionId: props.transaction.id,
        expenses: items.value.map(el => el.expenseId)
    }
    emit('submit', payload)
}



</script>